import React from "react";

import ServiceComponent from "../../utils/service-handler";

/**
 * Default class which has methods that are card-style independent.
 */
class Card extends ServiceComponent
{
    constructor(props) {
        super(props);

        // default to false for posts being new
        this.state = {
            isNew: false
        };
    }

    /**
     * Wraps an input card with an anchor tag if it exists. An anchor is used instead of
     * Link because of a problem with the Slick slider not being draggable.
     */
    LinkWrapper (props)
    {
        if (props.data.link && typeof props.data.link !== "undefined")
            return <a href={ props.data.link } title={ props.data.title } className="post-card-wrap-image">{ props.children }</a>
        return props.children;
    }

    /**
     * Returns if an has all the correct attributes and data.
     */
    isImageValid (featured_media) {
        return typeof featured_media !== 'undefined' && featured_media !== null && 
            typeof featured_media.node !== 'undefined' && featured_media.node !== null && 
            typeof featured_media.node.localFile !== 'undefined' && featured_media.node.localFile !== null && 
            typeof featured_media.node.localFile.childImageSharp !== 'undefined' && 
            featured_media.node.localFile.childImageSharp !== null && 
            typeof featured_media.node.localFile.childImageSharp.gatsbyImageData !== 'undefined' && 
            featured_media.node.localFile.childImageSharp.gatsbyImageData !== null;
    }
}

export default Card;